export enum PageName {
  LiveRoom = 'LiveRoom',
  LiveHome = 'LiveHome',
  H5LiveRoom = 'H5LiveRoom',
  NotFound = 'NotFound',
  ChargeStrip = 'ChargeStrip',  // 充能条 h5
  BlindBoxAward = 'BlindBoxAward', // 礼物盲盒开奖记录 h5
}

export const PageSpmId: Record<PageName, string> = {
  [PageName.LiveRoom]: '444.136',
  [PageName.LiveHome]: '444.144',
  [PageName.H5LiveRoom]: '333.1063',
  [PageName.NotFound]: '',
  [PageName.ChargeStrip]: '',
  [PageName.BlindBoxAward]: ''
};